
const state = {
    costItems: [],
    selectedCostItemIndex: null,
    selectedCostItem: {},
    totalCostAmount: null,
    newCostItem: {
        id: null,
        name: null,
        remarks: null,
        amount: null
    }
}

const getters = {
    getCustomInvoiceCostItems: (state) => {
        return state.costItems
    },
    getCustomInvoiceSelectedCostItem: (state) => {
        return state.selectedCostItem
    },
    getCustomInvoiceTotalCostAmount: (state) => {
        return state.totalCostAmount
    },
    getCustomInvoiceNewCostItem: (state) => {
        return state.newCostItem
    }
}

const mutations = {
    setCustomInvoiceCostItems: (state, newItems) => {
        state.costItems = newItems
    },
    setCustomInvoiceSelectedCostItem: (state, newItem) => {
        state.selectedCostItem = newItem
    },
    setCustomInvoiceSelectedCostItemIndex: (state, newItem) => {
        state.selectedCostItemIndex = newItem
    },
    setCustomInvoiceSelectedCostItemFieldValue: (state, data) => {
        state.selectedCostItem[data.field] = data.value
    },
    setCustomInvoiceNewCostItemFieldValue: (state, data) => {
        state.newCostItem[data.field] = data.value
    },
    pushNewCustomInvoiceNewCostItem: (state) => {
        state.costItems.push(state.newCostItem)
        state.newCostItem = { id: null, name: null, remarks: null, amount: null}
    },
    setCustomInvoiceTotalCostAmount: (state) => {
        let newValue = 0
        state.costItems.forEach(function(element) {
            newValue = Number(newValue) + Number(element.amount)
        })
        state.totalCostAmount = newValue

    },
    replaceCustomInvoiceCostItemWithSelectedCostItem: (state) => {
        state.costItems[state.selectedCostItemIndex] = state.selectedCostItem
        state.selectedCostItem = {}
    },
    removeCustomInvoiceCostItem: (state, item) => {
        state.costItems = state.costItems.filter(i => i !== item)
    }
}

const actions = {
    changeCustomInvoiceTotalCostAmount: ({ commit }) => {
        commit('setCustomInvoiceTotalCostAmount')
    },
    changeCustomInvoiceCostItems: ({ commit }, newItems) => {
        commit('setCustomInvoiceCostItems', newItems)
    },
    changeCustomInvoiceSelectedCostItem: ({ commit }, newItem) => {
        commit('setCustomInvoiceSelectedCostItem', newItem)
    },
    changeCustomInvoiceSelectedCostItemIndex: ({ commit }, newItem) => {
        commit('setCustomInvoiceSelectedCostItemIndex', newItem)
    },
    changeCustomInvoiceSelectedCostItemFieldValue: ({ commit }, newFieldValue) => {
        commit('setCustomInvoiceSelectedCostItemFieldValue', newFieldValue)
    },
    changeCustomInvoiceNewCostItemFieldValue: ({ commit }, newFieldValue) => {
        commit('setCustomInvoiceNewCostItemFieldValue', newFieldValue)
    },
    updateCustomInvoiceCostItem: ({ commit }) => {
        commit('replaceCustomInvoiceCostItemWithSelectedCostItem')
    },
    saveCustomInvoiceCostItem: ({ commit }) => {
        commit('pushNewCustomInvoiceNewCostItem' )
    },
    deleteCustomInvoiceCostItem: ({ commit }, item) => {
        commit('removeCustomInvoiceCostItem', item)
    }
}


export default { state, getters, mutations, actions }




// WEBPACK FOOTER //
// ./src/store/modules/customInvoiceCostItems.js